import styled, { css } from 'styled-components';
import { StatusButtonType } from '../ThemeProvider/types';

export const NavBarAnchor = styled.div`
  position: fixed;
  width: 100%;
  z-index: ${({ theme }) => theme.layers.intermediateMediumLayer};
`;

export const NavBarContainer = styled.div<{
  status: StatusButtonType;
  isMobile: boolean;
}>`
  align-items: center;
  ${({ theme, status, isMobile }) => css`
    background: ${theme.status[status].background};
    height: ${isMobile ? '60px' : '48px'};
  `}
  color: white;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: ${({ theme }) => theme.layers.intermediateMediumLayer};
`;

export const NavBarSpacer = styled.div<{
  isMobile: boolean;
}>`
  ${({ isMobile }) => css`
    height: ${isMobile ? '60px' : '48px'};
  `}
`;

export const MenuIconContainer = styled.div`
  padding-left: 20px;
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  gap: 8px;
  line-height: 18px;
`;

export const MiddleIcon = styled.div<{ onClick?: () => void }>`
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`;

export const MiddleIconContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: -1;
`;
export const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-right: 20px;
`;

export const NotificationContainer = styled.div`
  align-items: center;
  display: flex;
  & > div {
    cursor: pointer;
    margin-left: 8px;
  }
`;

export const UserContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  & > div {
    margin-left: 8px;
  }
`;

export const BlurContainer = styled.div<{
  isStateOpen: boolean;
}>`
  height: 100vh;
  position: fixed;
  top: 0;
  transition: all 0.2s;
  width: 100vw;
  z-index: -1;
  ${({ isStateOpen }) =>
    isStateOpen &&
    css`
      backdrop-filter: blur(4px);
      background: rgba(45, 45, 45, 0.3);
      z-index: ${({ theme }) => theme.layers.intermediateMediumLayer};
    `}
`;

export const FlagsContainer = styled.div`
  position: relative;
`;
export const ToggleFlag = styled.div`
  position: relative;
`;
